/**
 * Zweitschrift der Reichweiten-Vorgaben aus backend/src/documents/docTypes.ts. Dem im Repo
 * etablierten Muster folgend (frontend/src/api/bestellungen.ts:480-481 haelt die Feldliste aus
 * backend/src/domaene/feldgruppen.ts ebenso doppelt) - kein Ladeweg, keine eigene Route.
 * Der Waechtertest test/lib/dokumentReichweiteZweitschrift.test.ts haelt beide Fassungen zusammen.
 */
export const REICHWEITEN = ["bestellung", "gruppe", "sendung"] as const;

export type Reichweite = (typeof REICHWEITEN)[number];

export const REICHWEITE_VORGABEN: Record<string, Reichweite> = {
  seefracht_buchungsbestaetigung: "sendung",
  zollanweisung: "sendung",
  zollrechnung: "sendung",
  steuerbescheid: "sendung",
  speditionsangebot: "sendung",
  speditionsrechnung: "sendung",
  speditionsgebuehren: "sendung",
  cmr: "sendung",
  ankunftsavis: "sendung",
  sonstige: "sendung",
};

export function reichweiteVorgabe(docType: string): Reichweite {
  return REICHWEITE_VORGABEN[docType] ?? "bestellung";
}
